/* Nuvera theme script. ONE global file loaded from layout/theme.liquid, so every
   handler exists on every template. Section-scoped {% javascript %} bundles per
   page, which is how a checkout button ends up alive on the product page and
   dead everywhere else. */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* ---------- money ---------- */
  var FMT = (window.Nuvera && window.Nuvera.money) || '${{amount}}';
  function money(cents) {
    // Matches Liquid's money_without_trailing_zeros: whole amounts lose the
    // ".00", anything with real cents keeps them. The drawer and the page have
    // to format identically or the same number reads two ways.
    if (cents % 100 === 0) {
      var whole = String(cents / 100).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return FMT.replace(/\{\{\s*amount(_no_decimals)?(_with_comma_separator)?\s*\}\}/, whole);
    }
    var n = (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var noDec = (cents / 100).toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return FMT.replace(/\{\{\s*amount\s*\}\}/, n)
              .replace(/\{\{\s*amount_no_decimals\s*\}\}/, noDec)
              .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, n.replace(/,/g, '.').replace(/\.(\d\d)$/, ',$1'))
              .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, noDec);
  }

  /* ---------- cart ---------- */
  var PROT_ID = null;
  // An opt-out sticks for the session. Re-adding something the customer just
  // removed is what generates "they added charges without telling me".
  function declined() { try { return sessionStorage.getItem('nv-prot-declined') === '1'; } catch (e) { return false; } }
  function setDeclined(v) { try { sessionStorage.setItem('nv-prot-declined', v ? '1' : '0'); } catch (e) {} }

  function getCart() { return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); }

  // Resolve the add-on variant from the markup, not from the first paint. It
  // used to be set inside paint() only, so an add-to-cart that ran before the
  // first paint found PROT_ID null and quietly added nothing.
  function protBox() {
    var box = $('#prot-box');
    if (box && !PROT_ID) PROT_ID = Number(box.dataset.variant) || null;
    return box;
  }

  // What the checkbox should show: the cart wins, then a session opt-out, then
  // the Liquid-resolved default (off across the EEA and UK, on elsewhere).
  function protWanted(inCart) {
    var box = protBox();
    if (!box) return false;
    if (inCart) return true;
    if (declined()) return false;
    return box.dataset.protDefault !== 'off';
  }

  function paint(cart) {
    var body = $('#drawer-body'), foot = $('#drawer-foot');
    if (!body) return;
    $$('.cart-count').forEach(function (e) { e.textContent = cart.item_count; });

    var box = protBox();

    var prot = null, items = [];
    cart.items.forEach(function (it) {
      if (PROT_ID && it.variant_id === PROT_ID) prot = it; else items.push(it);
    });

    // Orphan guard: the add-on must never be the only thing left in the cart.
    if (!items.length && prot && !paint._clearing) {
      paint._clearing = true;
      fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: prot.key, quantity: 0 }) })
        .then(function (r) { return r.json(); }).then(paint).catch(function () {})
        .finally(function () { paint._clearing = false; });
      return;
    }

    if (!items.length) {
      body.innerHTML = '<div class="empty">Your cart is empty.</div>';
      if (foot) foot.style.display = 'none';
      return;
    }
    if (foot) foot.style.display = '';

    body.innerHTML = items.map(function (it) {
      var tier = (it.properties && it.properties._bundle) ? '<div class="ci__tier">' + it.properties._bundle + '</div>' : '';
      return '<div class="ci"><img src="' + (it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/i, '_120x$1$2') : '') + '" alt="">' +
        '<div><div class="ci__t">' + it.product_title + '</div>' +
        '<div class="ci__v">' + (it.variant_title && it.variant_title !== 'Default Title' ? it.variant_title : 'Qty ' + it.quantity) + '</div>' +
        tier + '<button class="ci__rm" data-key="' + it.key + '">Remove</button></div>' +
        '<div class="ci__p">' + money(it.final_line_price) + '</div></div>';
    }).join('');

    // Not `!!prot`: an empty cart would wipe the pre-tick on every load.
    if (box) box.checked = protWanted(!!prot);
    var sub = items.reduce(function (n, it) { return n + it.final_line_price; }, 0);
    var protRow = $('#prot-row');
    if (protRow) {
      protRow.hidden = !prot;
      if (prot && $('#sum-prot')) $('#sum-prot').textContent = money(prot.final_line_price);
    }
    if ($('#sum-sub')) $('#sum-sub').textContent = money(sub);
    if ($('#sum-tot')) $('#sum-tot').textContent = money(sub + (prot ? prot.final_line_price : 0));
    var saved = cart.total_discount || 0;
    // The real applied discount, not the compare-at saving on the tier card.
    if ($('#sum-saved')) $('#sum-saved').textContent = saved > 0 ? 'Bundle discount applied: ' + money(saved) : '';
  }

  function refresh() { return getCart().then(paint); }

  function addProtectionIfWanted() {
    var box = protBox();
    if (!box || !box.checked || !PROT_ID || declined()) return Promise.resolve();
    return getCart().then(function (c) {
      if (c.items.some(function (it) { return it.variant_id === PROT_ID; })) return;
      return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: PROT_ID, quantity: 1 }] }) });
    });
  }

  /* ---------- drawer ---------- */
  function openDrawer() {
    $('#drawer').classList.add('on'); $('#scrim').classList.add('on');
    $('#drawer').setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden';
  }
  function shutDrawer() {
    $('#drawer').classList.remove('on'); $('#scrim').classList.remove('on');
    $('#drawer').setAttribute('aria-hidden', 'true'); document.body.style.overflow = '';
  }
  function toast(msg) {
    var t = $('#toast'); if (!t) return;
    t.textContent = msg; t.classList.add('on');
    clearTimeout(toast._t); toast._t = setTimeout(function () { t.classList.remove('on'); }, 2400);
  }

  /* ---------- delegation ---------- */
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-open-cart]')) { e.preventDefault(); openDrawer(); refresh(); }
    if (e.target.closest('[data-shut-cart]') || e.target.id === 'scrim') shutDrawer();
    if (e.target.closest('[data-open-nav]')) $('#mnav').classList.toggle('on');

    var rm = e.target.closest('[data-key]');
    if (rm) {
      rm.disabled = true;
      fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: rm.dataset.key, quantity: 0 }) })
        .then(function (r) { return r.json(); }).then(paint);
    }

    var acc = e.target.closest('.acc__btn');
    if (acc) {
      var row = acc.closest('.acc__row'), open = row.classList.toggle('on');
      acc.setAttribute('aria-expanded', open);
    }
    var faq = e.target.closest('.faq__btn');
    if (faq) {
      var frow = faq.closest('.faq__row'), fopen = frow.classList.toggle('on');
      faq.setAttribute('aria-expanded', fopen);
    }

    // The drawer is on every page, so its checkout handler has to be too.
    var co = e.target.closest('#checkout');
    if (co && !co.disabled) {
      e.preventDefault(); co.disabled = true;
      addProtectionIfWanted().finally(function () { window.location.href = '/checkout'; });
    }

    var tier = e.target.closest('[data-tier]');
    if (tier) { TIER = +tier.dataset.tier; syncTier(); }

    var atc = e.target.closest('.atc');
    if (atc && !atc.disabled) addToCart(atc);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { shutDrawer(); if ($('#sizemodal')) $('#sizemodal').classList.remove('on'); }
  });

  document.addEventListener('change', function (e) {
    var box = e.target.closest('#prot-box');
    if (!box) return;
    protBox();
    if (box.checked) { setDeclined(false); addProtectionIfWanted().then(refresh); }
    else {
      setDeclined(true);
      getCart().then(function (c) {
        var line = c.items.filter(function (it) { return it.variant_id === PROT_ID; })[0];
        if (!line) return paint(c);
        return fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: line.key, quantity: 0 }) })
          .then(function (r) { return r.json(); }).then(paint);
      });
    }
  });

  /* ---------- product ---------- */
  var DATA = null, TIER = 0;

  function buildBuyBox() {
    var node = $('#nv-product-data'); if (!node) return;
    DATA = JSON.parse(node.textContent);
    var def = -1;
    DATA.tiers.forEach(function (t, i) { if (t.default && def < 0) def = i; });
    TIER = def < 0 ? 0 : def;
    syncTier();
  }

  function syncTier() {
    $$('.tier').forEach(function (el, i) {
      el.classList.toggle('on', i === TIER);
      el.setAttribute('aria-checked', i === TIER);
    });
    var t = DATA && DATA.tiers[TIER];
    var sp = $('#sticky-price');
    if (sp && t) sp.innerHTML = money(t.price) + '<s>' + money(t.was) + '</s>';
    var st = $('.sticky__t');
    if (st && t) st.textContent = DATA.title + ' - ' + t.title;
    syncAtc();
  }

  function syncAtc() {
    if (!DATA) return;
    var v = DATA.variants[0];
    var ready = !!(v && v.available);
    $$('.atc').forEach(function (b) {
      b.disabled = !ready;
      b.textContent = ready ? 'Add to cart' : 'Sold out';
    });
  }

  function addToCart(btn) {
    var t = DATA.tiers[TIER], v = DATA.variants[0];
    if (!v) return;
    // Identical units collapse into one line with a quantity. N separate lines
    // of the same variant give the customer a cart that looks like a mistake.
    var items = [{ id: v.id, quantity: t.qty, properties: { _bundle: t.title } }];
    btn.disabled = true;
    var label = btn.textContent;
    btn.textContent = 'Adding...';
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items }) })
      .then(function (r) { return r.json(); })
      .then(function () {
        var box = protBox();
        if (box) box.checked = protWanted(false);
        return addProtectionIfWanted();
      })
      .then(refresh)
      .then(function () { openDrawer(); toast('Added to cart'); })
      .catch(function () { toast('Could not add that. Try again.'); })
      .finally(function () { btn.textContent = label; syncAtc(); });
  }

  /* ---------- gallery ---------- */
  function buildGallery() {
    var main = $('#gal-main'); if (!main) return;
    var imgs = $$('img', main), thumbs = $$('#gal-thumbs button'), dots = $$('#gal-dots i');
    var at = 0;
    function show(n) {
      at = (n + imgs.length) % imgs.length;
      imgs.forEach(function (im, i) { im.classList.toggle('on', i === at); });
      thumbs.forEach(function (b, i) {
        b.classList.toggle('on', i === at);
        // The strip scrolls now, so the active thumbnail has to be brought
        // into view or it highlights somewhere off screen.
        if (i === at && b.offsetParent) {
          var strip = b.parentElement;
          var l = b.offsetLeft, r = l + b.offsetWidth;
          if (l < strip.scrollLeft) strip.scrollLeft = l - 8;
          else if (r > strip.scrollLeft + strip.clientWidth) strip.scrollLeft = r - strip.clientWidth + 8;
        }
      });
      dots.forEach(function (d, i) { d.classList.toggle('on', i === at); });
    }
    thumbs.forEach(function (b, i) { b.addEventListener('click', function () { show(i); }); });
    $$('[data-gal]').forEach(function (b) {
      b.addEventListener('click', function (e) { e.stopPropagation(); show(at + Number(b.dataset.gal)); });
    });

    // Axis decided once, on the first move, so a vertical scroll is never
    // captured by the carousel.
    var x0 = 0, y0 = 0, t0 = 0, axis = null, swiped = false;
    main.addEventListener('touchstart', function (e) {
      var t = e.touches[0]; x0 = t.clientX; y0 = t.clientY; t0 = Date.now(); axis = null; swiped = false;
    }, { passive: true });
    main.addEventListener('touchmove', function (e) {
      if (axis) return;
      var t = e.touches[0], dx = t.clientX - x0, dy = t.clientY - y0;
      if (Math.abs(dx) > 8 || Math.abs(dy) > 8) axis = Math.abs(dx) > Math.abs(dy) * 1.4 ? 'x' : 'y';
    }, { passive: true });
    main.addEventListener('touchend', function (e) {
      if (axis !== 'x') return;
      var dx = e.changedTouches[0].clientX - x0, dt = Date.now() - t0;
      if (Math.abs(dx) > 45 || (Math.abs(dx) > 25 && dt < 600)) { show(at + (dx < 0 ? 1 : -1)); swiped = true; }
    }, { passive: true });
    main.addEventListener('click', function (e) { if (swiped) { e.preventDefault(); e.stopPropagation(); } }, true);
    show(0);
  }

  /* ---------- countdowns ---------- */
  // The sticky bar shows only once the real Add to cart has left the screen,
  // at every width. It used to be permanently on below 900px and absent above,
  // so on desktop there was no second chance to buy after the fold.
  //
  // Driven by scroll position, not IntersectionObserver. The observer missed
  // large instantaneous jumps in both directions - the bar stayed hidden after
  // a jump down and stayed visible after a jump back to the top. Reading the
  // rect on each frame cannot miss a state, and it is one rect per frame.
  function buildStickyBar() {
    var bar = $('#sticky-bar');
    var anchor = $('#buybox .atc');
    if (!bar || !anchor) return;
    var shown = null, queued = false;
    function apply() {
      queued = false;
      // Past it = its bottom edge is above the top of the viewport.
      var on = anchor.getBoundingClientRect().bottom < 0;
      if (on === shown) return;
      shown = on;
      bar.classList.toggle('on', on);
      bar.setAttribute('aria-hidden', on ? 'false' : 'true');
    }
    function queue() { if (!queued) { queued = true; requestAnimationFrame(apply); } }
    addEventListener('scroll', queue, { passive: true });
    addEventListener('resize', queue, { passive: true });
    apply();
  }

  // Buy box photo rail: arrows scroll by one card and disable at the ends.
  // Pointer/touch scrolling works on its own; this is only the desktop affordance.
  function buildBuyBoxRail() {
    var track = $('[data-bxrail-track]');
    if (!track) return;
    var arrows = $$('[data-bxrail]');
    function step() {
      var first = track.firstElementChild;
      return first ? first.getBoundingClientRect().width + 12 : 160;
    }
    function sync() {
      var max = track.scrollWidth - track.clientWidth - 1;
      arrows.forEach(function (b) {
        var back = Number(b.dataset.bxrail) < 0;
        b.disabled = back ? track.scrollLeft <= 1 : track.scrollLeft >= max;
      });
    }
    arrows.forEach(function (b) {
      b.addEventListener('click', function () {
        track.scrollBy({ left: Number(b.dataset.bxrail) * step(), behavior: 'smooth' });
      });
    });
    track.addEventListener('scroll', sync, { passive: true });
    addEventListener('resize', sync, { passive: true });
    sync();
  }

  function buildTimers() {
    var nodes = $$('[data-countdown]');
    if (!nodes.length) return;
    function tick() {
      nodes.forEach(function (n) {
        var mins = Number(n.dataset.countdown) || 15;
        var key = 'nv-cd-' + (n.dataset.cdKey || 'default');
        var end;
        try { end = Number(sessionStorage.getItem(key)); } catch (e) { end = 0; }
        if (!end || end < Date.now()) { end = Date.now() + mins * 60000; try { sessionStorage.setItem(key, end); } catch (e) {} }
        var left = Math.max(0, end - Date.now());
        var h = Math.floor(left / 3600000), m = Math.floor(left % 3600000 / 60000), s = Math.floor(left % 60000 / 1000);
        var pad = function (x) { return x < 10 ? '0' + x : '' + x; };
        n.textContent = (n.dataset.cdHours === 'true' ? pad(h) + ':' : '') + pad(m) + ':' + pad(s);
      });
    }
    tick();
    setInterval(tick, 1000);
  }

  function boot() { buildBuyBox(); buildGallery(); buildStickyBar(); buildBuyBoxRail(); buildTimers(); refresh(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
